module.exports = __webpack_public_path__ + "static/media/Prime.526677e9.jpg";